// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;I do not occupy myself with great matters,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;with things that are too high for me.<br> </p> </div></div>";
// Exports
module.exports = code;